import _defineProperty from "/Users/daugustine/Other/adidas-training-website-2021/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/Users/daugustine/Other/adidas-training-website-2021/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/daugustine/Other/adidas-training-website-2021/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/daugustine/Other/adidas-training-website-2021/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/daugustine/Other/adidas-training-website-2021/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/daugustine/Other/adidas-training-website-2021/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/* eslint-env browser */

/* eslint-disable no-unused-vars, no-redeclare, no-shadow */
import * as React from "react";
import { driver, getInitialStyle } from "styletron-standard";
import { addDebugMetadata, setupDevtoolsExtension, DebugEngine } from "./dev-tool";
export { DebugEngine };
var noopEngine = {
  renderStyle: function renderStyle() {
    return "";
  },
  renderKeyframes: function renderKeyframes() {
    return "";
  },
  renderFontFace: function renderFontFace() {
    return "";
  }
};
var StyletronContext = /*#__PURE__*/React.createContext(noopEngine);
var HydrationContext = /*#__PURE__*/React.createContext(false);
var DebugEngineContext = /*#__PURE__*/React.createContext(undefined); //todo: theme context removed
var DevProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(DevProvider, _React$Component);
  var _super = _createSuper(DevProvider);
  function DevProvider(props) {
    var _this;
    _classCallCheck(this, DevProvider);
    _this = _super.call(this, props);
    _this.state = {
      hydrating: Boolean(props.debugAfterHydration)
    };
    return _this;
  }
  _createClass(DevProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (true) {
        if (this.state.hydrating === true) {
          this.setState({
            hydrating: false
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(StyletronContext.Provider, {
        value: this.props.value
      }, /*#__PURE__*/React.createElement(DebugEngineContext.Provider, {
        value: this.props.debug
      }, /*#__PURE__*/React.createElement(HydrationContext.Provider, {
        value: this.state.hydrating
      }, this.props.children)));
    }
  }]);
  return DevProvider;
}(React.Component);
export var Provider = true && process.env.NODE_ENV !== "production" ? DevProvider : StyletronContext.Provider;
if (true && process.env.NODE_ENV !== "production" && !window.__STYLETRON_DEVTOOLS__) {
  setupDevtoolsExtension();
}
function checkNoopEngine(engine) {
  // if no engine provided, we default to no-op, handy for tests
  // however, print a warning in other envs
  if (process.env.NODE_ENV !== "test") {
    engine === noopEngine &&
    // eslint-disable-next-line no-console
    console.warn(process.env.NODE_ENV !== "production" ? "\nStyletron has been switched to a no-op (test) mode.\n\nA Styletron styled component was rendered, but no Styletron engine instance was provided in React context.\n\nDid you forget to provide a Styletron engine instance to React context via using the Styletron provider component?\n\nNote: Providers and Consumers must come from the exact same React.createContext call to work.\nIf your app has multiple instances of the \"styletron-react\" package in your node_module tree,\nyour Provider may be coming from a different React.createContext call, which means the styled components\nwill not recieve the provided engine instance. This scenario can arise, for example, when using \"npm link\".\n" : "Styletron Provider is not set up. Defaulting to no-op.");
  }
}
export function useStyletron() {
  var styletronEngine = React.useContext(StyletronContext);
  var debugEngine = React.useContext(DebugEngineContext);
  var hydrating = React.useContext(HydrationContext);
  checkNoopEngine(styletronEngine);
  var debugClassName = React.useRef("");
  var prevDebugClassNameDeps = React.useRef([]);
  return [function css(style) {
    var className = driver(style, styletronEngine);
    if (!(true && process.env.NODE_ENV !== "production")) {
      return className;
    }
    var _Error = new Error("stacktrace source"),
      stack = _Error.stack,
      message = _Error.message;
    var nextDeps = [debugEngine, hydrating];
    if (prevDebugClassNameDeps.current[0] !== nextDeps[0] || prevDebugClassNameDeps.current[1] !== nextDeps[1]) {
      if (debugEngine && !hydrating) {
        debugClassName.current = debugEngine.debug({
          stackInfo: {
            stack: stack,
            message: message
          },
          stackIndex: 1
        });
      }
      prevDebugClassNameDeps.current = nextDeps;
    }
    if (debugClassName.current) {
      return "".concat(debugClassName.current, " ").concat(className);
    }
    return className;
  }];
}
export function createStyled(_ref) {
  var getInitialStyle = _ref.getInitialStyle,
    driver = _ref.driver,
    wrapper = _ref.wrapper;
  function styled(base, styleArg) {
    if (process.env.NODE_ENV !== "production") {
      if (base.__STYLETRON__) {
        /* eslint-disable no-console */
        console.warn("It appears you are passing a styled component into `styled`.");
        console.warn("For composition with existing styled components, use `withStyle` or `withTransform` instead.");
        /* eslint-enable no-console */
      }
    }

    var baseStyletron = {
      reducers: [],
      base: base,
      driver: driver,
      getInitialStyle: getInitialStyle,
      wrapper: wrapper
    };
    if (true && process.env.NODE_ENV !== "production") {
      addDebugMetadata(baseStyletron, 2);
    }
    return createStyledElementComponent(autoComposeShallow(baseStyletron, styleArg));
  }
  return styled;
}
export var styled = createStyled({
  getInitialStyle: getInitialStyle,
  driver: driver,
  wrapper: function wrapper(Component) {
    return Component;
  }
});
export var withTransform = function withTransform(component, transformer) {
  var styletron = component.__STYLETRON__;
  if (true && process.env.NODE_ENV !== "production") {
    addDebugMetadata(styletron, 2);
  }
  return createStyledElementComponent(composeDynamic(styletron, transformer));
};
export var withStyleDeep = function withStyleDeep(component, styleArg) {
  // @ts-ignore
  var styletron = component.__STYLETRON__;
  if (process.env.NODE_ENV !== "production") {
    if (!styletron) {
      /* eslint-disable no-console */
      console.warn("The first parameter to `withStyle` must be a styled component (without extra wrappers).");
      /* eslint-enable no-console */
    }
  }

  if (true && process.env.NODE_ENV !== "production") {
    addDebugMetadata(styletron, 2);
    return createStyledElementComponent(addExtension(autoComposeDeep(styletron, styleArg), component, styleArg));
  } else {
    return createStyledElementComponent(autoComposeDeep(styletron, styleArg));
  }
};
export var withStyle = withStyleDeep;
export var withWrapper = function withWrapper(component, wrapper) {
  var styletron = component.__STYLETRON__;
  if (process.env.NODE_ENV !== "production") {
    if (!styletron) {
      /* eslint-disable no-console */
      console.warn("The first parameter to `withWrapper` must be a styled component (without extra wrappers).");
      /* eslint-enable no-console */
    }
  }

  var composed = {
    getInitialStyle: styletron.getInitialStyle,
    base: styletron.base,
    driver: styletron.driver,
    wrapper: wrapper,
    reducers: styletron.reducers
  };
  if (true && process.env.NODE_ENV !== "production") {
    addDebugMetadata(composed, 2);
  }
  return createStyledElementComponent(composed);
};
export function autoComposeShallow(styletron, styleArg) {
  if (typeof styleArg === "function") {
    return dynamicComposeShallow(styletron, styleArg);
  }
  return staticComposeShallow(styletron, styleArg);
}
function addExtension(composed, component, styleArg) {
  return _objectSpread(_objectSpread({}, composed), {}, {
    ext: {
      with: styleArg,
      name: component.displayName,
      base: component.__STYLETRON__.base,
      getInitialStyle: component.__STYLETRON__.reducers.length ? component.__STYLETRON__.reducers[0].reducer : component.__STYLETRON__.getInitialStyle
    }
  });
}
export function autoComposeDeep(styletron, styleArg) {
  if (typeof styleArg === "function") {
    return dynamicComposeDeep(styletron, styleArg);
  }
  return staticComposeDeep(styletron, styleArg);
}
export function staticComposeShallow(styletron, style) {
  return composeStatic(styletron, createShallowMergeReducer(style));
}
export function staticComposeDeep(styletron, style) {
  return composeStatic(styletron, createDeepMergeReducer(style));
}
export function dynamicComposeShallow(styletron, styleFn) {
  return composeDynamic(styletron, function (style, props) {
    return shallowMerge(style, styleFn(props));
  });
}
export function dynamicComposeDeep(styletron, styleFn) {
  return composeDynamic(styletron, function (style, props) {
    return deepMerge(style, styleFn(props));
  });
}
export function createShallowMergeReducer(style) {
  return {
    reducer: function reducer(inputStyle) {
      return shallowMerge(inputStyle, style);
    },
    assignmentCommutative: true,
    factory: createShallowMergeReducer,
    style: style
  };
}
export function createDeepMergeReducer(style) {
  return {
    reducer: function reducer(inputStyle) {
      return deepMerge(inputStyle, style);
    },
    assignmentCommutative: true,
    factory: createDeepMergeReducer,
    style: style
  };
}
export function composeStatic(styletron, reducerContainer) {
  if (styletron.reducers.length === 0) {
    var style = reducerContainer.reducer(styletron.getInitialStyle());
    var result = {
      reducers: styletron.reducers,
      base: styletron.base,
      driver: styletron.driver,
      wrapper: styletron.wrapper,
      getInitialStyle: function getInitialStyle() {
        return style;
      }
    };
    if (true && process.env.NODE_ENV !== "production") {
      result.debug = styletron.debug;
    }
    return result;
  } else {
    var last = styletron.reducers[0];
    if (last.assignmentCommutative === true && reducerContainer.assignmentCommutative === true) {
      var composed = reducerContainer.reducer(last.style);
      var _result = {
        getInitialStyle: styletron.getInitialStyle,
        base: styletron.base,
        driver: styletron.driver,
        wrapper: styletron.wrapper,
        reducers: [last.factory(composed)].concat(styletron.reducers.slice(1))
      };
      if (true && process.env.NODE_ENV !== "production") {
        _result.debug = styletron.debug;
      }
      return _result;
    }
    return composeDynamic(styletron, reducerContainer.reducer);
  }
}
export function composeDynamic(styletron, reducer) {
  var composed = {
    getInitialStyle: styletron.getInitialStyle,
    base: styletron.base,
    driver: styletron.driver,
    wrapper: styletron.wrapper,
    // @ts-ignore
    reducers: [{
      assignmentCommutative: false,
      reducer: reducer
    }].concat(styletron.reducers)
  };
  if (true && process.env.NODE_ENV !== "production") {
    composed.debug = styletron.debug;
  }
  return composed;
}
export function createStyledElementComponent(styletron) {
  var reducers = styletron.reducers,
    base = styletron.base,
    driver = styletron.driver,
    wrapper = styletron.wrapper,
    getInitialStyle = styletron.getInitialStyle,
    ext = styletron.ext;
  if (true && process.env.NODE_ENV !== "production") {
    var debugStackInfo, debugStackIndex;
    if (styletron.debug) {
      debugStackInfo = styletron.debug.stackInfo;
      debugStackIndex = styletron.debug.stackIndex;
    }
  }
  if (true && process.env.NODE_ENV !== "production") {
    var debugClassName;
  }
  var StyledElement = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var styletron = React.useContext(StyletronContext);
    var debugEngine = React.useContext(DebugEngineContext);
    var hydrating = React.useContext(HydrationContext);
    checkNoopEngine(styletron);
    var elementProps = omitPrefixedKeys(props);
    var style = resolveStyle(getInitialStyle, reducers, props);
    if (props.$style) {
      if (typeof props.$style === "function") {
        style = deepMerge(style, props.$style(props));
      } else {
        style = deepMerge(style, props.$style);
      }
    }
    var styleClassString = driver(style, styletron);
    var Element = props.$as ? props.$as : base;
    elementProps.className = props.className ? "".concat(props.className, " ").concat(styleClassString) : styleClassString;
    if (true && process.env.NODE_ENV !== "production" && debugEngine && !hydrating) {
      if (!debugClassName) {
        debugClassName = debugEngine.debug({
          stackInfo: debugStackInfo,
          stackIndex: debugStackIndex
        });
      }
      var joined = "".concat(debugClassName, " ").concat(elementProps.className);
      elementProps.className = joined;
    }
    if (true && process.env.NODE_ENV !== "production" && window.__STYLETRON_DEVTOOLS__) {
      window.__STYLETRON_DEVTOOLS__.stylesMap.set(elementProps.className, style);
      if (ext) {
        window.__STYLETRON_DEVTOOLS__.extensionsMap.set(elementProps.className, {
          base: ext.base,
          displayName: ext.name,
          initialStyles: ext.getInitialStyle({}, props),
          styleOverrides: typeof ext.with === "function" ? ext.with(props) : ext.with
        });
      }
    }
    if (props.$ref) {
      // eslint-disable-next-line no-console
      console.warn("The prop `$ref` has been deprecated. Use `ref` instead. Refs are now forwarded with React.forwardRef.");
    }
    return /*#__PURE__*/React.createElement(Element, _extends({}, elementProps, {
      ref: ref || props.$ref
    }));
  });
  var Wrapped = wrapper(StyledElement);
  Wrapped.__STYLETRON__ = {
    base: base,
    reducers: reducers,
    driver: driver,
    wrapper: wrapper,
    getInitialStyle: getInitialStyle
  };
  if (process.env.NODE_ENV !== "production") {
    var displayName;
    if (typeof base === "string") {
      displayName = base;
    } else if (base.displayName) {
      displayName = base.displayName;
    } else if (base.name) {
      displayName = base.name;
    } else {
      displayName = "Unknown";
    }
    Wrapped.displayName = "Styled(".concat(displayName, ")");
  }
  return Wrapped;
} // Utility functions

export function resolveStyle(getInitialStyle, reducers, props) {
  var result = getInitialStyle();
  var i = reducers.length;
  while (i--) {
    // Cast to allow passing unused props param in case of static reducer
    var reducer = reducers[i].reducer;
    result = reducer(result, props);
  }
  return result;
}
function isObject(x) {
  return typeof x === "object" && x !== null;
}
function omitPrefixedKeys(source) {
  var result = {};
  for (var key in source) {
    if (key[0] !== "$") {
      result[key] = source[key];
    }
  }
  return result;
}
function deepMerge(a, b) {
  var result = assign({}, a);
  for (var key in b) {
    var val = b[key];
    if (isObject(val) && isObject(a[key])) {
      result[key] = deepMerge(a[key], val);
    } else {
      result[key] = val;
    }
  }
  return result;
}
function shallowMerge(a, b) {
  return assign(assign({}, a), b);
}
function assign(target, source) {
  for (var key in source) {
    target[key] = source[key];
  }
  return target;
}